/**
 * Apply sticky class to header and matching padding to body
*/

import EventBus from './../event-bus.js'
import jQuery from 'jquery'

class StickyHeader {
    
    /**
     * Construct component
     * @param nav
    */
    constructor(nav) {
        
        /**
         * Header navigation
         * @type object
        */
        this.nav = nav
        
        this.bindEvents()
        
    }
    
    /**
     * Run component
    */
    run() {
        
        let stickyClass = this.nav.data('sticky-class')
        this.nav.addClass(stickyClass ? stickyClass : 'fixed-top')
        
        this.updateBodyPadding()
        
    }
    
    /**
     * Update body padding
    */
    updateBodyPadding() {
        jQuery('body').css('padding-top', this.nav.outerHeight())
    }
    
    /**
     * Bind events
    */
    bindEvents() {
        
        //Bind run modules event
        EventBus.subscribe('run-modules', this.run.bind(this))
        
        //Bind window resize event
        jQuery(window).resize(this.updateBodyPadding.bind(this))
        
        //Bind header resized event
        EventBus.subscribe('header.resized', this.updateBodyPadding.bind(this))
        
    }
    
}

EventBus.subscribe('init-modules',  () => {
    
    let nav = jQuery('#header-nav')
    
    if (nav.length > 0) {
        new StickyHeader(nav)
    }
    
})

export default StickyHeader